var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AppPremise {
    parent;
    wasPremiseModalClosedByUser = false;
    isFullscreenSwitchActive = true;
    get app() {
        return this.parent;
    }
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get hasPremises() {
        if (!runtime.availablePackages.Exotic)
            return false;
        if (this.isSwitchToChromeBrowserRequired)
            return true;
        // if (this.isSwitchToFullScreenRequired) return true;
        // if (this.app.media.starter.isMediaRestrainedUntilFirstUserInteraction) return true;
        return false;
    }
    get isSwitchToChromeBrowserRequired() {
        if (!runtime.availablePackages.Defer)
            return false; // browser detection in defer
        if (runtime.solidBrowserRuntime.browserAgent.isChrome)
            return false;
        if (!runtime.availablePackages.Exotic)
            return false;
        if (!this.app.recognition.recognitionRequests.isRecognitionRequiredByApp)
            return false;
        if (this.app.user && this.app.user.userData.isAdmin)
            return false;
        if (this.app.appInfo.isAppInEditBuild)
            return false;
        return true;
    }
    get isWaitingForFirstUserInteraction() {
        if (!runtime.availablePackages.Defer)
            return false;
        if (this.app.media.mediaPlayer.intents.length === 0)
            return false;
        if (!this.app.media.mediaStarter.wasAutoplayTested)
            return false;
        if (this.app.media.mediaStarter.isAutoPlayPossible)
            return false;
        return true;
    }
    get isWaitingForFullScreen() {
        if (!runtime.isBrowserRuntime)
            return false;
        if (this.app.appInfo.isMobileAppWebView)
            return false;
        if (runtime.solidBrowserRuntime.browserFullscreen.isInFullscreen)
            return false;
        if (runtime.solidBrowserRuntime.browserDevice.isTabletOrSmartphone)
            return true;
        return false;
    }
    closeMenubarPremise() {
        this.app.appPremise.wasPremiseModalClosedByUser = true;
    }
}
__decorate([
    observable
], AppPremise.prototype, "wasPremiseModalClosedByUser", void 0);
__decorate([
    observable
], AppPremise.prototype, "isFullscreenSwitchActive", void 0);
__decorate([
    action.bound
], AppPremise.prototype, "closeMenubarPremise", null);
